/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import PageLayout from '../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../../Assets/svg/CityIcon.svg";
// import { ReactComponent as HomeIcon } from "../../Assets/svg/HomeIcon.svg";
// import { ReactComponent as InfrainstractureIcon } from "../../Assets/svg/InfrainstractureIcon.svg";
// import { ReactComponent as RoomsIcon } from "../../Assets/svg/RoomsIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as MapMarkerIcon } from "../../Assets/svg/MapMarkerIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
import {
    useParams
} from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import ButtonNavigation from '../../Components/ButtonNavigation';
import DmandAdaptItem from '../../Components/DmandAdaptItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { useSearchDemandStore } from '../../store/searchDemand';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import useForceUpdate from 'use-force-update';
import { useUserStore } from '../../store/user';
import moment from "moment-jalaali"
import { ReactComponent as DownloadIcon } from "../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonList } from "../../Assets/svg/PersonList.svg";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../../Components/persian-mobile-datepicker-config'
import { priceItems, meterItems, dateTypes } from "../../api/ListData"
import { scrollingDiv } from '../../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'
import { InView } from 'react-intersection-observer';
import ModalComponent from "../../Components/ModalComponent";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};






function AdaptDemand(props) {

    const { enqueueSnackbar } = useSnackbar();

    let { id, row } = useParams()

    const [tabValue, setTabValue] = React.useState(0);

    const [areasItems, setAreasItems] = React.useState([]);
    const [inPlusing, setInPlusing] = React.useState(true);

    const [moreModal, setMoreModal] = React.useState(false);


    const [showMeterItem, setShowMeterItem] = React.useState(1);

    const [nowDate, setNowDate] = React.useState("");
    const [yearDates, setYearDates] = React.useState([]);

    const [openSearchTypeModal, setOpenSearchTypeModal] = React.useState(false);

    const [showSearchType, setShowSearchType] = React.useState('');
    const [changeFlag, setChangeFlag] = React.useState(false);

    const [hasMore, setHasMore] = React.useState(true);
    const [propLoading, setPropLoading] = React.useState(false);
    const [ofsset, setOfsset] = React.useState(0);
    const dataFetchedRef = useRef(false);
    const [adapts, setAdapts] = React.useState([]);
    const [propKey, setPropKey] = React.useState(0);

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const locationId = useUserStore((state) => state.locationId)

    const navigation = useNavigate();
    const forceUpdate = useForceUpdate();

    const searchData = useSearchDemandStore((state) => state.searchData)
    const setSearchData = useSearchDemandStore((state) => state.setSearchData)
    const emptySearchData = useSearchDemandStore((state) => state.emptySearchData)

    const searchType = searchData.SearchType
    const limit = 10

    const [adaptPercent, setAdaptPercent] = useState(false);
    const [percentAdaptValue, setPercentAdaptValue] = useState("");
    const [minRegisterDate, setMinRegisterDate] = useState(null);
    const [maxRegisterDate, setMaxRegisterDate] = useState(null);
    const [minRegisterDateModal, setMinRegisterDateModal] = useState(false);
    const [maxRegisterDateModal, setMaxRegisterDateModal] = useState(false);

    const handleClickSearchTypeModal = () => {
        setOpenSearchTypeModal(true);
    };



    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };



    const handleClickRentPriceModal = () => {
        setRentPriceModal(true);
    };



    const handleClickSalePriceModal = () => {
        setSalePriceModal(true);
        setShowMeterItem(1)
    };



    const handleClickMoreModal = () => {
        setMoreModal(true);
        var searchTmp = searchType
        emptySearchData()
        setSearchData({ name: "SearchType", value: searchTmp });
        scrollingDiv()

        setTimeout(function () { document.getElementById("floorNo-container").scroll(650, 0) }, 500)
    }


    const handleTabChange = (event, newValue) => {
        console.log("newValue", newValue)
        setTabValue(newValue);
    };



    useEffect(() => {
        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        for (let i = parseInt(now); i >= parseInt(now) - 51; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }

        console.log("date", moment().format('YYYY-M-D'))
        var d = new Date(moment().format('YYYY-M-D'))

    }, [])

    useEffect(() => {
        if (changeFlag) {
            getAdapt(true)
            console.log('run use efect')
        }
    }, [searchData])

    useEffect(() => {
        getAdapt(true)
    }, [percentAdaptValue, minRegisterDate, maxRegisterDate])


    const getAdapt = (resetState = false) => {
        // console.log("searchDataaaa", searchData)
        if (resetState) {
            setAdapts([])
            console.log("reset", adapts)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setPropLoading(true)

        try {
            http({
                // url of the api endpoint (can be changed)
                url: `/applicants/${id}/adapt`,
                method: "POST",
                data: {
                    LocationId: Cookies.get('locationId'),
                    Limit: limit,
                    AgencyInfo: true,
                    AdaptPercent: percentAdaptValue,
                    MinRegisterDate: minRegisterDate?.valueOf() / 1000,
                    MaxRegisterDate: maxRegisterDate?.valueOf() / 1000,
                    AdaptDivar: 0,
                    Offset: resetState ? 0 : ofsset
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("propres", res.data.result.Properties);

                const tmpProp = [...adapts]
                if (res.data.result.Properties.length > 0) {
                    if (!resetState) {
                        res.data.result.Properties.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setAdapts(tmpProp)
                        console.log("resetState not")
                    }
                    else
                        setAdapts(res.data.result.Properties)

                    console.log("proper", adapts)

                    setPropKey(propKey => propKey++)
                } else {
                    console.log("End")
                    setHasMore(false)
                    if (resetState) setAdapts([])

                }
                setTimeout(function () { setInPlusing(true) }, 1000)
                setPropLoading(false)
                setChangeFlag(false)
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
            setChangeFlag(false)
        }


    }

    // const onScroll = () => {
    //     if (document.getElementById("dashboard-content")) {
    //         const scrollTop = document.getElementById("dashboard-content").scrollTop
    //         const scrollHeight = document.getElementById("dashboard-content").scrollHeight
    //         const clientHeight = document.getElementById("dashboard-content").clientHeight
    //         if (scrollTop + clientHeight >= scrollHeight && inPlusing) {
    //             setOfsset(ofsset => ofsset + limit);
    //             setInPlusing(false)
    //             // setSearchData({"name":"Offset","value":ofsset})
    //             console.log("ofsset", ofsset)
    //         }
    //     }
    // }

    // useEffect(() => {
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && adapts.length > 0) {
    //             document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
    //             return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
    //         }
    //     }, 500)
    // }, [adapts])

    const handlePlusOffset = (inView) => {
        console.log("🚀 ~ handlePlusPropOffset ~ inView:", inView)

        if (inView && !propLoading && hasMore) {
            setOfsset(ofsset => ofsset + limit);
        }
    }

    useEffect(() => {
        console.log("offset use")

        if (hasMore && adapts.length) {
            getAdapt()
        }
    }, [ofsset])


    useEffect(() => {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // emptySearchData()



        getAdapt()


    }, [])


    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    const handleDeletedProps = (id) => {
        let tmpProperties = [...adapts]
        // console.log("tmpProperties",tmpProperties,adapts)
        tmpProperties = tmpProperties.filter(item => item.Id != id)
        setAdapts(tmpProperties)
    }

    const handleSetAdaptPercent = async (e) => {

        let AdaptPercent = e.target.value;

        if (!e.target.checked) {
            AdaptPercent = ""
        }

        setPercentAdaptValue(AdaptPercent);
        setAdaptPercent(false);

        //getAdapt(true)
    }

    return (
        <>
            <PageLayout title={`املاک منطبق با تقاضا ${row}`} key={propKey}>
                <Box id="dashboard-content" sx={{ pt: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="standard"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        className='tab-nav'
                        dir="rtl"

                    >
                        <Tab label="درصد انطباق" className={`tab-nav-item ${percentAdaptValue ? 'tab-active' : ""}`} onClick={() => setAdaptPercent(true)} />
                        <Tab
                            className={`tab-nav-item ${minRegisterDate ? 'tab-active' : ""}`}
                            onClick={() => setMinRegisterDateModal(true)}
                            label={<div>
                                <span>{ minRegisterDate ? `از ${formatJalali(minRegisterDate)}` : "از تاریخ" }</span>
                                {minRegisterDate != null && <IconButton sx={{ p: '2px', marginRight: '5px' }} onClick={(e) => {
                                    setMinRegisterDate(null)
                                    e.stopPropagation()
                                }}><CloseIcon height='12px' width='12px' /></IconButton>}
                            </div>}
                        />
                        <Picker
                            isOpen={minRegisterDateModal}
                            config={config}
                            value={minRegisterDate}
                            initialValue={new Date(minRegisterDate ? new Date(minRegisterDate) : new Date())}
                            minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                            maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                            onSubmit={(selectedDate) => setMinRegisterDate(selectedDate.date)}
                            // onChange={}
                            onClose={() => setMinRegisterDateModal(false)}
                            highlightWeekends
                        />
                        <Tab
                            className={`tab-nav-item ${maxRegisterDate ? 'tab-active' : ""}`}
                            onClick={() => setMaxRegisterDateModal(true)}
                            label={<div>
                                <span>{ maxRegisterDate ? `تا ${formatJalali(maxRegisterDate)}` : "تا تاریخ" }</span>
                                {maxRegisterDate != null && <IconButton sx={{ p: '2px', marginRight: '5px' }} onClick={(e) => {
                                    setMaxRegisterDate(null)
                                    e.stopPropagation()
                                }}><CloseIcon height='12px' width='12px' /></IconButton>}
                            </div>}
                        />
                        <Picker
                            isOpen={maxRegisterDateModal}
                            config={config}
                            value={maxRegisterDate}
                            initialValue={new Date(maxRegisterDate ? new Date(maxRegisterDate) : new Date())}
                            minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                            maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                            onSubmit={(selectedDate) => setMaxRegisterDate(selectedDate.date)}
                            // onChange={}
                            onClose={() => setMaxRegisterDateModal(false)}
                            highlightWeekends
                        />

                    </Tabs>
                    <Box sx={{ px: 3, py: 1 }} >
                        {
                            adapts && adapts.length > 0 ?
                                adapts.map((item, index) => (
                                    <DmandAdaptItem key={index} propInfo={item} applicantId={id} handleDeletedProps={handleDeletedProps} />
                                ))
                                : !propLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                        }
                        {
                            propLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                        }
                        <InView
                            as='div'
                            onChange={(inView, entry) =>
                                handlePlusOffset(inView, entry)
                            }></InView>
                    </Box>
                </Box>
                <ButtonNavigation />

            </PageLayout>

            {adaptPercent && <ModalComponent
                showModalState={adaptPercent}
                handleModalClose={() => setAdaptPercent(false)}
                modalTitle="فیلتر درصد انطباق"
                disableSubmitBtn={true}
            >
                <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt1' className="d-none typeCheck" name="percentAdapt" value="<50" checked={percentAdaptValue == "<50"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt1' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>کمتر از 50 درصد</div>
                        </label>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt2' className="d-none typeCheck" name="percentAdapt" value="50-80" checked={percentAdaptValue == "50-80"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt2' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>بین 50 تا 80 درصد</div>
                        </label>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt3' className="d-none typeCheck" name="percentAdapt" value=">80" checked={percentAdaptValue == ">80"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt3' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>80 درصد به بالا</div>
                        </label>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt4' className="d-none typeCheck" name="percentAdapt" value="nothing" checked={percentAdaptValue == "nothing"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt4' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>مشخص نشده</div>
                        </label>
                    </Box>
                </Box>
            </ModalComponent>}

        </>
    );
}

export default AdaptDemand;